import React, { useState, useEffect } from "react";
import Context from "../../Context";
import {
  Container,
  Typo,
  Flex,
  Button,
  Grid,
  Badge,
  ContentContainer,
  Input,
  Breadcrumb,
  LoadingIcon,
} from "../../components";
import {
  getThaiDateAndTimeFormat,
  getThaiDateFormat,
  statusColor,
  statusTranslated,
  statuses,
  validate,
} from "../../constants";
import { IoIosArrowForward } from "react-icons/io";
import styled from "styled-components";
import themes from "../../themes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { monthTh } from "../../util";
import { Collapse, Modal, Spinner } from "reactstrap";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { o } from "ramda";

export const CouponOrder = () => {
  const { callApi, go, configs, profileState, update } = Context();
  const [order, setOrder] = useState([]);
  const [filteredCoupons, setFilteredCoupons] = useState(false);
  const [isShowMyCoupon, setIsShowMyCoupon] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [isShowReserveModal, setIsShowReserveModal] = useState(false);
  const [selectedReserveCoupon, setSelectedReserveCoupon] = useState({});
  const [body, setBody] = useState({
    number: undefined,
    quantity: false,
  });

  const [couponType, setCouponType] = useState("reserve");
  const currentDate = window.Date.now();
  const { orderId } = useParams();
  const location = useLocation();

  useEffect(() => {
    getMyCoupon();
  }, []);

  const getMyCoupon = async () => {
    setIsLoading(true);
    const result = await callApi(
      "coupons-getTransactionByUserId",
      {},
      { notShowLoading: true }
    );
    const coupon = result.data.find(
      (order) =>
        order.id === orderId &&
        order.status === statuses.APPROVE &&
        order.coupon.type === "reserve"
    );

    if (!coupon) {
      go("/coupon");
      return;
    }

    console.log("coupon", coupon);
    setOrder(coupon);
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-96">
        <Spinner className="text-navy" />
      </div>
    );
  }

  return (
    <Container margin="20px 0 70px 0">
      <Breadcrumb
        data={[
          { path: "/", name: "หน้าแรก" },
          { path: "/coupon", name: "คูปอง" },
          { name: `คำสั่งซื้อ #${order?.shortId || "      "}` },
        ]}
      />

      <div className="bg-white rounded-sm p-3 mt-6 w-full shadow-sm">
        <p className=" font-semibold text-lg">
          คูปอง {order?.coupon?.name}
          <span className="text-navy font-semibold text-sm ml-2">
            #{order?.shortId}
          </span>
        </p>
        <div className="bg-gray-300 my-2 w-full h-[1px]"></div>
        <div className="grid grid-cols-2 gap-2 mt-3">
          <div>
            <p className="font-semibold">วันที่สั่งซื้อ</p>
            <p className="text-sm text-gray-600">
              {getThaiDateAndTimeFormat(new Date(order?.createdAt))}
            </p>
          </div>
          <div>
            <p className="font-semibold">สถานะ</p>
            <p className="text-sm bg-[rgb(59,176,101)] text-white px-2 py-1 rounded-sm w-fit font-semibold ">
              {(order?.coupon?.reserveOrder || []).length ==
              order.coupon.quantity
                ? "ครบทุกสิทธิ์"
                : (order?.coupon?.reserveOrder || []).length > 0
                ? "กำลังใช้สิทธิ์"
                : "ยังไม่ใช้สิทธ์"}
              {/* <div>{statusTranslated[order?.coupon.status]}</div> */}
            </p>
          </div>

          <div>
            <p className="font-semibold">วันหมดอายุ</p>
            <p className="text-sm text-gray-600">
              {getThaiDateAndTimeFormat(new Date(order?.coupon?.expireAt))}
            </p>
          </div>
          <div>
            <p className="font-semibold">จำนวนสิทธ์ที่ใช้แล้ว</p>
            <p className="text-sm text-gray-600 font-semibold">
              {(order?.coupon?.reserveOrder || []).length} /{" "}
              {order?.coupon?.quantity}
            </p>
          </div>
        </div>
        {order?.coupon?.type === "reserve" &&
          (order?.coupon?.reserveOrder || []).length <=
            order?.coupon?.quantity && (
            <div>
              <div className="bg-gray-300 mt-3 w-full h-[1px]"></div>
              <div className="grid grid-cols-2 gap-2 mt-3">
                <div>
                  <p className="font-semibold">เลขท้ายที่ต้องการ</p>
                  <input
                    className="border-1 w-full sm:w-32 h-fit text-center placeholder:text-center border-gray-300 py-1.5 px-2 font-semibold rounded-sm placeholder:text-sm"
                    value={body.number}
                    type="number"
                    placeholder={
                      order?.coupon?.reserveType !== "lastThree" ? "xx" : "xxx"
                    }
                    onChange={(e) => {
                      const reserveType =
                        order?.coupon?.reserveType !== "lastThree" ? 2 : 3;
                      if (e.target.value.length <= reserveType) {
                        setBody((prevState) => ({
                          ...prevState,
                          number: e.target.value,
                        }));
                      }
                    }}
                  />
                </div>
                <div>
                  <p className="font-semibold">จำนวนใบ</p>
                  <input
                    className="border-1 w-full sm:w-40 h-fit text-center placeholder:text-center border-gray-300 py-1.5 px-2 font-semibold rounded-sm placeholder:text-sm"
                    type="number"
                    value={body.quantity}
                    placeholder={`จองได้สูงสุด ${order?.coupon?.limitPerUsed} ใบ/ครั้ง`}
                    onChange={(e) => {
                      if (e.target.value <= order?.coupon?.limitPerUsed) {
                        setBody((prevState) => ({
                          ...prevState,
                          quantity: e.target.value,
                        }));
                      }
                    }}
                  />
                </div>
              </div>

              <button
                disabled={
                  body.number?.length !==
                    (order?.coupon?.reserveType !== "lastThree" ? 2 : 3) ||
                  body.quantity <= 0 ||
                  body.quantity > order?.coupon?.limitPerUsed ||
                  isLoading
                }
                className="bg-[rgb(59,176,101)] text-white w-full px-2 py-2 mt-6 rounded-sm font-semibold disabled:bg-slate-200 disabled:cursor-not-allowed hover:opacity-70"
                onClick={async () => {
                  if (
                    order.coupon.quantity > order.coupon.reserveOrder.length &&
                    body.quantity >= 1
                  ) {
                    const result = await callApi("coupons-addReserveOrder", {
                      id: order.id,
                      number: body.number,
                      quantity: body.quantity,
                    });

                    if (result) {
                      getMyCoupon();
                      setBody({ number: undefined, quantity: undefined });
                    }
                  }
                }}
              >
                จองเลขท้าย
              </button>
            </div>
          )}
      </div>
      {order?.coupon?.reserveOrder.length > 0 && (
        <div className="bg-white rounded-sm p-3 mt-6 w-full shadow-sm">
          <p className="font-semibold text-lg">คำสั่งซื้อการจอง</p>

          {order?.coupon?.reserveOrder?.map((order, i) => {
            return (
              <div
                className="border border-gray-200 shadow-sm p-3 rounded-sm mt-3"
                key={i}
              >
                <div className="grid grid-cols-3 gap-1">
                  <div>
                    <p className="font-semibold ">เลขท้าย</p>
                    <p className="font-semibold text-gray-600 ml-2">
                      {order?.number}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold text-center">จำนวน</p>
                    <p className="font-semibold text-gray-600 text-center">
                      {order?.quantity}
                    </p>
                  </div>
                  <div>
                    <p className="font-semibold text-right">สถานะ</p>
                    <div
                      className={`flex justify-end
`}
                    >
                      <p
                        className={`${
                          order?.status === statuses.PENDING
                            ? "bg-[#FAB12F]"
                            : "bg-[rgb(59,176,101)]"
                        } font-semibold text-white p-1 text-xs rounded-sm `}
                      >
                        {order?.status === statuses.PENDING
                          ? "รอดำเนินการ"
                          : "สร้างคำสั่งซื้อแล้ว"}
                      </p>
                    </div>
                  </div>
                </div>
                {order.orderId && (
                  <div className="">
                    <div className="bg-gray-300 my-3 w-full h-[1px]"></div>
                    <p className="font-semibold text-xl">
                      คำสั่งซื้อ{" "}
                      <span className="text-[rgb(59,176,101)]">
                        #{order?.shortId}
                      </span>
                    </p>
                    <div className="grid grid-cols-3 gap-2 mt-3">
                      <div>
                        <p className="font-semibold">หมดอายุ</p>
                        <p className="text-sm text-gray-600 ">
                          {getThaiDateAndTimeFormat(new Date(order?.expireAt))}
                        </p>
                      </div>
                      <div>
                        <p className="font-semibold text-center">ราคา</p>
                        <p className="font-semibold text-gray-600 text-center">
                          {order?.totalPrice} บาท
                        </p>
                      </div>{" "}
                      <div>
                        <p className="font-semibold text-right">จำนวน</p>
                        <p className="font-semibold text-gray-600 text-right">
                          {order?.size} ใบ
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => go(`/orders`)}
                      className="w-full bg-navy text-white py-2 px-1 rounded-sm text-sm font-semibold text-center mt-3 hover:opacity-70"
                    >
                      ดูรายละเอียดคำสั่งซื้อ
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </Container>
  );
};
// แก้ไข
// หน้า "คูปองจองสิทธิ์"
// ทำคล้ายๆหน้า "คำสั่งซื้อคูปอง"
// โชว์เฉพาะออเดอร์ที่มีคำสั่งซื้อคูปอง "สำเร็จ" เท่านั้น

// สถานะ
// - ยังไม่ใช้สิทธ์ = กรณีที่ยังไม่มีการจองของลูกค้า

// - กำลังใช้สิทธิ์ = มีการจองเลขเข้ามา แต่ยังไม่มีการจัดออเดอร์ให้ลูกค้า , หรือจัดออเดอร์ยังไม่ครบตามจำนวนที่ลูกค้าสั่ง

// - ครบทุกสิทธิ์ = จัดออเดอร์ให้ลูกค้าครบทุกสิทธิ์ตามจำนวนคำสั่งซื้อ เพื่อรอชำระเงิน

// - เสียสิทธิ์ = กรณี ลูกค้าไม่มีการชำระเงินมา
